// import React from 'react';
// import ReactApexChart from 'react-apexcharts';

// const BankerTemperatureIndices = ({ indices }) => {
//   var weather_dates = [];
//   var rainfall_list = [];

//   if (indices && Array.isArray(indices)) {
//     indices.forEach(element => {
//       weather_dates.push(element.date);
//       rainfall_list.push(Number(element.TEMPERATURE.toFixed(2)));
//     });
//   }

//   const weather_tick_amount = rainfall_list.length > 0 ? Math.ceil(rainfall_list.length / 8) : 1;
//   const weather_min = Math.min(...rainfall_list);
//   const weather_max = Math.max(...rainfall_list);

//   const state = {
//     options: {
//       grid: {
//         show: true,
//         borderColor: '#cadbdb',
//         strokeDashArray: 0,
//         position: 'back',
//         xaxis: {
//           lines: {
//             show: true
//           }
//         },
//         yaxis: {
//           lines: {
//             show: true
//           }
//         }
//       },
//       chart: {
//         height: 500,
//         type: 'area'
//       },
//       dataLabels: {
//         enabled: false
//       },
//       stroke: {
//         curve: 'smooth',
//         width: 3
//       },
//       colors: ['#2E93fA'],
//       xaxis: {
//         categories: weather_dates,
//         tickAmount: weather_tick_amount
//       },
//       yaxis: {
//         min: weather_min,
//         max: weather_max,
//         tickAmount: 8
//       }
//     },
//     series: [
//       {
//         name: 'Rainfall',
//         data: rainfall_list
//       }
//     ]
//   };

//   return (
//     <React.Fragment>
//       <ReactApexChart options={state.options} series={state.series} type="area" height="380" />
//     </React.Fragment>
//   );
// }

// export default BankerTemperatureIndices;

import { max } from "lodash";
import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const filterDataBySeason = (data, season) => {
  return data.filter((item) => item.season === season);
};

const getMonthsList = (season) => {
  return season === "Rabi"
  ? [ "Dec", "Jan", "Feb", "Mar", "Apr", "May", ]
  : [ "Jun", "Jul", "Aug", "Sep", "Oct", "Nov"];
};

const prepareChartData = (indices, season) => {
  const seasonData = filterDataBySeason(indices, season);
  const monthsList = getMonthsList(season);
  const monthlyData = {};

  seasonData.forEach((item) => {
    item?.indices.forEach((element) => {
      const date = new Date(element.date);
      const year = date.getFullYear();
      const monthName = date.toLocaleString("default", { month: "short" });

      if (!monthlyData[year]) {
        monthlyData[year] = {};
      }

      if (!monthlyData[year][monthName]) {
        monthlyData[year][monthName] = 0;
      }

      if ((monthlyData[year][monthName] || 0) < element.TEMPERATURE) {
        monthlyData[year][monthName] = element.TEMPERATURE;
      }
    });
  });

  const series = Object.keys(monthlyData).map((year) => ({
    name: `${season} ${year}`,
    data: monthsList.map((month) => monthlyData[year][month] || 0),
  }));

  return { series, monthsList };
};

const getChartOptions = (monthsList, seriesData) => ({
  grid: {
    show: true,
    borderColor: "#cadbdb",
  },
  chart: {
    height: 500,
    type: "area",
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    width: 1,
  },
  colors: ["#2E93fA", "#66DA26", "#FF4560", "#775DD0"],
  xaxis: {
    categories: monthsList,
    labels: {
      formatter: (value) => value,
    },
  },
  yaxis: {
    min: 0,
    max: max(seriesData.map((s) => max(s.data))),
    tickAmount: 5,
    labels: {
      formatter: (value) => value.toFixed(2),
    },
  },
  tooltip: {
    enabled: true,
    shared: true,
    intersect: false,
    x: { format: "MMM" },
    y: { formatter: (value) => value.toFixed(2) },
  },
});

const BankerTemperatureIndices = ({ indices }) => {
  const [kharifData, setKharifData] = useState({ series: [], monthsList: [] });
  const [rabiData, setRabiData] = useState({ series: [], monthsList: [] });

  useEffect(() => {
    setKharifData(prepareChartData(indices, "Kharif"));
    setRabiData(prepareChartData(indices, "Rabi"));
  }, [indices]);

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
      <div style={{ flex: "1 1 45%" }}>
        <h3 style={{ textAlign: "center" }}>Kharif</h3>
        <ReactApexChart
          options={getChartOptions(kharifData.monthsList, kharifData.series)}
          series={kharifData.series}
          type="area"
          height="400"
        />
      </div>
      <div style={{ flex: "1 1 45%" }}>
        <h3 style={{ textAlign: "center" }}>Rabi</h3>
        <ReactApexChart
          options={getChartOptions(rabiData.monthsList, rabiData.series)}
          series={rabiData.series}
          type="area"
          height="400"
        />
      </div>
    </div>
  );
};

export default BankerTemperatureIndices;

